export default __webpack_public_path__ + "d7c841699906c66b8e0ed996ce6e9bd9.png";